import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import { baseVuetifyOptions } from '~/vuetify/options';

export default defineNuxtPlugin((app) => {
  const light = {
    dark: false,
    colors: {
      // Brand colors
      primary: '#2F523E',
      secondary: '#A8ABAC',
      'secondary-darken': '#888888',
      accent: '#FF8966',
      progress: '#92BFDD',
      'progress-darken': '#245575',
      // Semantic colors
      error: '#B00020',
      info: '#FBB03B',
      success: '#4CAF50',
      warning: '#FB8C00',
      'warning-darken': '#8A4D00',
      highlight: '#32CD32',
      // Surface & background tokens
      background: '#F8F9FA',
      surface: '#FFFFFF',
      'on-surface': '#212121',
      'background-tint': '#C4EBD0',
      // Legacy aliases (keep for backwards compat)
      white: '#FFFFFF',
      black: '#14242E',
      font: '#2F523E',
      'light-grey': '#E6E6E6',
      grey: '#CCCCCC',
      'grey-darken': '#A8ABAC',
      'tls-green': '#4CAF50',
    },
  };

  const vuetify = createVuetify({
    ...baseVuetifyOptions,
    ssr: false,
    theme: {
      defaultTheme: 'light',
      themes: {
        light,
      },
    },
  });

  app.vueApp.use(vuetify);
});
